module.exports = __webpack_public_path__ + "img/selectable_04.e7eb29d8.png";